// Polyfill for usehooks-ts useUnmount until we upgrade to v3

import { useEffect, useRef } from "react";

export const useUnmount = (func) => {
  const funcRef = useRef(func);

  funcRef.current = func;

  useEffect(
    () => () => {
      funcRef.current();
    },
    []
  );
};
